import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Home, Trophy, BookOpen, MessageSquare, Settings, Award, User, Bell } from 'lucide-react';

export default function MobileBottomNav({ role }) {
  const navigate = useNavigate();
  const location = useLocation();
  
  const getNavItems = () => {
    if (role === 'admin') {
      return [
        { icon: Home, label: 'Басты', path: '/admin', color: '#6366f1' },
        { icon: Trophy, label: 'Есептер', path: '/admin/reports', color: '#f59e0b' },
        { icon: Bell, label: 'Хабар', path: '/messages', color: '#3b82f6' },
        { icon: Settings, label: 'Баптау', path: '/admin', tab: 'settings', color: '#64748b' },
      ];
    }
    
    if (role === 'teacher') {
      return [
        { icon: Home, label: 'Басты', path: '/teacher', color: '#6366f1' },
        { icon: Award, label: 'Ұпай', path: '/teacher', tab: 'assign', color: '#10b981' },
        { icon: BookOpen, label: 'Сыныбым', path: '/teacher', tab: 'myclass', color: '#f59e0b' },
        { icon: Bell, label: 'Хабар', path: '/messages', color: '#3b82f6' },
      ];
    }
    
    // Student
    return [
      { icon: Home, label: 'Басты', path: '/student', color: '#6366f1' },
      { icon: Trophy, label: 'Жетістік', path: '/student', section: 'gamification', color: '#f59e0b' },
      { icon: BookOpen, label: 'Кітап', path: '/student', section: 'bookchat', color: '#10b981' },
      { icon: Bell, label: 'Хабар', path: '/messages', color: '#3b82f6' },
    ];
  };
  
  const navItems = getNavItems();
  
  const isActive = (item) => {
    return item.path === location.pathname && !item.section && !item.tab;
  };
  
  const handleNavClick = (item) => {
    if (item.section) {
      navigate(item.path);
      setTimeout(() => {
        const element = document.querySelector(`[data-section="${item.section}"]`);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100);
    } else {
      navigate(item.path);
    }
  };
  
  return (
    <nav className="mobile-bottom-nav">
      {navItems.map((item, index) => {
        const Icon = item.icon;
        const active = isActive(item);
        
        return (
          <button
            key={index}
            onClick={() => handleNavClick(item)}
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '8px 12px',
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              borderRadius: 12,
              transition: 'all 0.2s ease',
            }}
          >
            <div
              style={{
                width: 44,
                height: 44,
                borderRadius: 14,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                background: active ? item.color : 'transparent',
                transition: 'all 0.3s ease',
                marginBottom: 4,
                boxShadow: active ? `0 4px 12px ${item.color}40` : 'none',
              }}
            >
              <Icon 
                size={22} 
                style={{
                  color: active ? 'white' : '#64748b',
                  strokeWidth: active ? 2.5 : 2,
                  transition: 'all 0.2s ease',
                }}
              />
            </div>
            <span style={{
              fontSize: 11,
              fontWeight: active ? 700 : 500,
              color: active ? '#1e293b' : '#64748b',
              transition: 'all 0.2s ease',
              letterSpacing: '-0.01em',
            }}>
              {item.label}
            </span>
          </button>
        );
      })}
    </nav>
  );
}
